var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "global-accordion",
      class: [
        _vm.theme,
        _vm.enumerate ? "accordion--enumeration" : "",
        _vm.open ? "accordion--open" : "accordion--close",
      ],
    },
    [
      _c(
        "div",
        {
          staticClass: "global-accordion__header",
          class: [_vm.headerType, _vm.inactive],
          on: { click: _vm.toggle },
        },
        [
          _c(
            "header",
            { class: _vm.headerWidth },
            [
              _vm.accordionType === "3"
                ? [
                    _c(
                      "span",
                      { staticClass: "icon-toggle", class: _vm.buttonState },
                      [
                        _c("span", { staticClass: "horizontal" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "vertical" }),
                      ]
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.accordionType === "2"
                ? [
                    _vm.enumerate
                      ? _c("span", { staticClass: "header__enumeration" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.enumerate) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "h2",
                      { staticClass: "headline-2" },
                      [_vm._t("header")],
                      2
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.accordionType === "3"
                ? [
                    _c(
                      "h3",
                      [
                        _vm._t("header"),
                        _vm._v(" "),
                        _vm.enumerate
                          ? _c("span", { staticClass: "header__enumeration" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.enumerate) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.accordionType === "2"
                ? [
                    _c(
                      "span",
                      { staticClass: "icon-toggle", class: _vm.buttonState },
                      [
                        _c("span", { staticClass: "horizontal" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "vertical" }),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: { name: "accordion" },
          on: {
            "before-enter": _vm.beforeEnter,
            enter: _vm.enter,
            "after-enter": _vm.enterTo,
            "before-leave": _vm.beforeLeave,
            leave: _vm.leave,
            "after-leave": _vm.leaveTo,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.open,
                  expression: "open",
                },
              ],
              staticClass: "accordion__body",
              class: { "accordion__body--staged": _vm.useContentStage },
            },
            [_vm._t("body")],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }